import Vue from 'vue';
import qs from 'qs';
import i18n from '@/langs/i18n.js';

export default class ListUtils {
  static loadItemsData (instance, config) {
    instance.loaded = false;
    instance.loadError = false;
    let requestMethod = 'post';
    let parameters = config.params || {};

    if (config.method) {
      requestMethod = config.method;
    }

    if (config.method === 'get') {
      parameters = {
        params: parameters,
        paramsSerializer: params => qs.stringify(params)
      };
    }

    instance.$http[requestMethod](config.endpoint, parameters, {
      withCredentials: true
    }).then(response => {
      if (response.data && response.data.success === 0) {
        throw new Error('Invalid response');
      }

      instance[config.listField] = response.data.data;
      instance.loaded = true;

      if (config.pagination) {
        instance.paginationMetaData = response.data.meta || null;
      }

      if (config.successAction) {
        config.successAction();
      }
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
      if (config.failAction) {
        config.failAction();
      }
    });
  }

  static removeItem (instance, config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: i18n.t('ui.yesRemove'),
      cancelButtonText: i18n.t('ui.cancel')
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase + config.id, {}, {
          withCredentials: true
        }).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }

  static bulkActionItems (instance, config) {
    let selectedItems = config.items || [];

    selectedItems = {
      items: selectedItems
    };

    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: i18n.t('ui.yes'),
      cancelButtonText: i18n.t('ui.cancel')
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpoint, selectedItems, {
          withCredentials: true
        }).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }
}
